module.exports = __webpack_public_path__ + "img/request-feature.5ef311b.png";